
// el tipo: se refiere a si es actuacion, carpeta u audiencia
export const TiposLaboral: { [key: string]: number } = {
    ACTUACION: 1,
    AUDIENCIA: 2,
    CARPETA: 3
};

// EL cveTipoDoc se refiere unicamente al tipo de carpeta
export const CveTiposDocumentosLaboral: { [key: string]: number } = {
    ACTUACIONES_GENERAL: 1,
    EXPEDIENTE: 1,
    EXHORTO: 2,
    AMPARO: 3,
    CUADERNO: 4
};

// el tipo: se refiere a si es actuacion, carpeta u audiencia
export const TiposPenal: { [key: string]: number } = {
    ACTUACION: 1,
    AUDIENCIA: 2,
    CARPETA: 5
};



export const CveTipoDocumentoPenal: { [key: string]: number } = {
    GENERAL: 1,
};
